import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Navigation, MapPin } from 'lucide-react';
import { toast } from 'sonner';

const RadiusFilter = ({ userLocation, onRadiusChange, selectedRadius }) => {
  const radiusOptions = [
    { value: 1, label: '1 km', color: 'bg-green-500' },
    { value: 5, label: '5 km', color: 'bg-blue-500' },
    { value: 10, label: '10 km', color: 'bg-purple-500' },
    { value: 20, label: '20 km', color: 'bg-red-500' },
    { value: null, label: 'Tout', color: 'bg-gray-500' }
  ];

  const handleRadiusSelect = (radius) => {
    if (radius !== null && !userLocation) {
      toast.error('Géolocalisation requise', {
        description: 'Activez la géolocalisation pour filtrer par distance'
      });
      return;
    }
    onRadiusChange(radius);
  };

  return (
    <Card className="border-2 border-purple-200 bg-white/90 backdrop-blur">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center gap-2">
          <Navigation className="w-4 h-4 text-purple-600" />
          Recherche par Distance
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {!userLocation && (
          <div className="text-xs text-amber-600 bg-amber-50 p-2 rounded flex items-start gap-2">
            <MapPin className="w-3 h-3 mt-0.5 shrink-0" />
            <span>Activez la géolocalisation pour filtrer par rayon</span>
          </div>
        )}
        
        <div className="grid grid-cols-5 gap-2">
          {radiusOptions.map((option) => (
            <button
              key={option.value || 'all'}
              onClick={() => handleRadiusSelect(option.value)}
              className={`px-2 py-2 text-xs font-medium rounded-lg transition-all ${
                selectedRadius === option.value
                  ? `${option.color} text-white shadow-lg scale-105`
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>

        {selectedRadius && userLocation && (
          <div className="text-xs text-purple-700 bg-purple-50 p-2 rounded flex items-center gap-2">
            <MapPin className="w-3 h-3" />
            <span>Offres dans un rayon de {selectedRadius}km</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RadiusFilter;
